import React, {Component} from 'react';
import cookie from 'react-cookies'
import fire from '../Config-Files/firebaseconfig.js';
import TextInput from '../Material-UI-Components/TextInput.js';
import Grid from '@material-ui/core/Grid';
import Password from '../Material-UI-Components/TextPassword';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner';

const loginModule=[
    { "id":"1", "columnName":"Email Address", "fieldName":"emailAddress", "isReadOnly":false, "autocomplete":"off", "fieldType":"text", "required": true},
    { "id":"2", "columnName":"Password", "fieldName":"password", "isReadOnly":false,  "autocomplete":"off", "fieldType":"password", "required": true}
];

export default class LoginModule extends Component{

    constructor(props)
    {
        super(props);
        this.state={
            user:{},
            loader: false,
            error: ''
        }
        this.login = this.login.bind(this);
        this.authListener = this.authListener.bind(this);
    }

    componentDidMount()
    {
        this.authListener();
    }

    componentWillMount()
    {
        loginModule.map((index)=>{
            this.setState({[index.fieldName]:index.default ? index.default :''});
        });
    }
  
    setStateValueOnClick = (key, value) => {
        this.setState({[key]:value});
    };

    login()
    {
        this.setState({loader:true});
        fire.auth().signInWithEmailAndPassword(this.state.emailAddress,this.state.password).then((user)=>{
            cookie.save('uid', user["user"]["uid"], { path: '/' });
            cookie.save('refreshToken', user["user"]["refreshToken"]);
            this.setState({loader:false, error:''});
            this.props.onClickFunction('login', 'success');
        }).catch((err)=>{
            this.setState({loader:false, error:"Invalid username or password"});
        })
    }

    authListener(){
        fire.auth().onAuthStateChanged((user)=>{
            if(user)
            {
                this.setState({user});
            }
            else
            {
                this.setState({user:null});
            }
        })
    }

    getTableContent = () => {
  
        const getFieldType = (nextItem) => {
          switch (nextItem.fieldType) {
            case "text":
                return (<TextInput value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} disableReadonly = {this.props.disableReadonly} onClickFunction = {this.setStateValueOnClick}/>);
            case "password":
                return (<Password value={this.state[nextItem.fieldName]} fieldConfiguration={nextItem} disableReadonly = {this.props.disableReadonly} onClickFunction = {this.setStateValueOnClick}/>)
            default:
              return null;
          }
        };
      
        const iterateItem = (item) => {
           return item.map(function (nextItem, j) {
            return (
              <Grid xs={12} sm={6} md={8}>
                {getFieldType(nextItem)}
              </Grid>
           );
           })
        }
            return (
                <div>
                  {iterateItem(loginModule)}
                </div>
            );
      };

    render()
    {
        const elements = this.getTableContent();
        return(
            <div>
                {elements}
                <div style={{marginTop:10, marginLeft:10}}>
                {this.state.loader? 
                <Loader type="Circles" color="#f7941e" height={40} width={40}/>
                :
                <div>
                <div style={{color:'#FF0000'}}>{this.state.error}</div>
                <Button 
                    onClick={() => this.login()} 
                    style={{marginTop:20, 
                    color: '#ffffff', 
                    backgroundColor: '#f7941e', 
                    fontSize: 13}}
                >
                {"Login"}
                </Button>
                </div>
                }
                </div>
            </div>
        )
    }
}